import React, { Component } from 'react';
import { Container, Header, Segment, Icon, Loader, Dimmer } from 'semantic-ui-react';
import Moment from 'moment';
import { connect } from 'react-redux';

import { getAuthenticatorOTP } from '../../actions';

class AuthenticatorPage extends Component {
    componentDidMount() {
        const { accessToken } = this.props.user;
        this.props.getAuthenticatorOTP({ accessToken });
    }

    handleRefresh = () => {
        const { accessToken } = this.props.user;
        this.props.getAuthenticatorOTP({ accessToken });
    }

    renderContent() {
        const { isLoading, otpCodes } = this.props.authenticator;

        if (isLoading) {
            return (
                <Segment style={{ minHeight: 80 }}>
                    <Dimmer active inverted>
                        <Loader inverted>Loading</Loader>
                    </Dimmer>
                </Segment>
            );
        }

        if (!otpCodes || otpCodes.length === 0) {
            return (
                <Segment>
                    <p style={{ color: '#2c689c', margin: 0 }}>No authenticator OTP codes available.</p>
                </Segment>
            );
        }

        return (
            <Segment>
                {otpCodes.map((item, index) => (
                    <div key={index} style={{ marginBottom: index < otpCodes.length - 1 ? 16 : 0 }}>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                            <Icon name='lock' style={{ color: '#2c689c' }} />
                            <span style={{ marginRight: 8, fontWeight: 600, color: '#2c689c' }}>OTP Code:</span>
                            <span style={{
                                backgroundColor: '#f0f4f8',
                                border: '1px solid #d0dce8',
                                borderRadius: 4,
                                padding: '2px 10px',
                                letterSpacing: 2,
                                fontWeight: 600,
                                color: '#333',
                                fontSize: '1em'
                            }}>
                                {item.messageData && item.messageData.otp}
                            </span>
                        </div>
                        <div style={{ paddingLeft: 24, color: '#888', fontSize: '0.9em' }}>
                            Expires: {item.messageData && Moment(item.messageData.expiryDate).format('DD MMM YYYY hh:mm A')}
                        </div>
                    </div>
                ))}
                <div style={{ textAlign: 'right', marginTop: 16 }}>
                    <span
                        onClick={this.handleRefresh}
                        style={{ color: '#2c689c', cursor: 'pointer', fontWeight: 500 }}
                    >
                        Refresh
                    </span>
                </div>
            </Segment>
        );
    }

    render() {
        return (
            <Container fluid>
                <Header as='h2' attached='top' block>
                    My Authenticator
                </Header>
                {this.renderContent()}
            </Container>
        );
    }
}

const mapStateToProps = (state) => ({
    user: state.user.user,
    authenticator: state.authenticator,
});

export default connect(mapStateToProps, { getAuthenticatorOTP })(AuthenticatorPage);
